import React, { Suspense } from "react";
import { NavLink } from "react-router-dom";
import { withAlert } from "react-alert";
import { withTranslation } from "react-multi-lang";
import {
    Silentauditobject, Servicecalls, Getuserprojectfromsession, Getuserworkflowfromsession,
    orderType, onGetUserControlRights, AuditTrailValidation, Manualauditobject
} from "./../custom_functions/Functions.jsx";
import store from "../redux_store/store/index";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { CustomButtonCell } from "./columnMenu.jsx";
import { Shareorder, Downloadfile, Deletefile, Viewfile, EditFile } from "../custom_functions/ManipulationFunction";
import { Customordercells, } from "./CustomDetailviewCell";
import { MyGlobalContext } from "../custom_modules/orders/Sheetorder";
import { isMultitenant } from "../custom_functions/Constance.jsx";
import $ from "jquery";
const Audit = React.lazy(() => import("./../custom_modules/Audit.jsx"));

let rights;
class PendingViewCell extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.dataItem["link"],
            filetype: this.props.dataItem["filetype"],
            isAssignedOrder: this.props.dataItem["assignedto"] === undefined ? false : true,
            orderflag: this.props.dataItem["orderflag"],
            controlRights: onGetUserControlRights("Sheet"),
            audit: false
        };
        this.ELNurl = window.appUrl.ELN;
        this.props = props;
    }

    componentDidMount() {
        this._isMounted = true;
        const controlRights = onGetUserControlRights("Sheet");
        this.setState({ controlRights });
        rights = this.context;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.dataItem["link"],
            filetype: this.props.dataItem["filetype"],
            isAssignedOrder: this.props.dataItem["assignedto"] === undefined ? false : true,
            orderflag: this.props.dataItem["orderflag"],
        });
    }
    onAuditValidateError(res) { }

    onAuditValidateFailure(res) { }

    setClickPopover(e, event) {
        this.setState({
            popOverLeft: e.clientX,
            popOverTop: e.clientY,
            eventKey: event === this.state?.eventKey ? false : event
        })
    }
    handleMouseOut = () => {
        let body = document.getElementsByClassName("modal-open");
        if (!body.length) {
            this.setState({
                eventKey: false
            })
        }
    };

    onbuttonclick(e) {

        let passObjDet = {
            objsilentaudit: Silentauditobject("copy", "Sheet Orders",
                this.props.t("Orders.Sheetorders.IDS_AUDIT_COPYORDER", {
                    screen: orderType(this.state.filetype),
                    batchid: this.props.dataItem.batchid,
                    user: store.getState().Loggeduser.username
                })
            ),
        };
        Servicecalls(
            "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
            passObjDet,
            this.onAuditValidateError.bind(this),
            this.onAuditValidateFailure.bind(this)
        );
        this.props.alert.success(this.props.t("Orders.Sheetorders.IDS_MSG_COPYLINK", {
            batchid: this.props.dataItem.batchid,
            screenname: isMultitenant === 2 ? this.props.t("Dashboard.IDS_LBL_TASK") :
                this.props.t("Dashboard.IDS_LBL_ORDER")
        }));
    }

    onUnShareClick = (event, item) => {
        this.props.openunsharelist(item);
    };

    onordercommonaction = (event, item) => {
        this.props.onordercommonaction(item)
    }

    stopautoregister = (event, item) => {
        this.props.stopautoregister(item)
    }

    openNewTab = () => {
        this.Auditcancel();
        let order = this.props.dataItem.order;
        let projects = Getuserprojectfromsession();
        let workflow = Getuserworkflowfromsession();
        order.lstproject = projects;
        order.lstworkflow = workflow;
        let passdata = {
            order: order, rights: rights, user: store.getState().Loggeduser,
            tenantid: sessionStorage.getItem("tenantid"), token: sessionStorage.getItem("Token"),
            loginTime: sessionStorage.getItem("LoginTime"), loggedfrom: sessionStorage.getItem("loggedfrom"),
            azuretoken: sessionStorage.getItem("azuretoken"), tenantdomain: sessionStorage.getItem("tenantdomain"),
            screen: "Sheet",
            multiusergroups: sessionStorage.multiusergroups,
            userpasscodeencrypted: sessionStorage.userpasscodeencrypted,
            packagetype: isMultitenant === 0 ? "3" : sessionStorage.getItem("packagetype"),
            teamusercode: sessionStorage.getItem("teamusercode"),
            username: sessionStorage.Username,
            idletime: sessionStorage.idletime
        };
        localStorage.setItem("linkedorder", JSON.stringify(passdata));

        window.open(`${process.env.PUBLIC_URL}/vieworder`, "_blank");
    }

    Auditcancel = () => {
        $("#newTabAudit1").modal("hide");
        this.setState({ audit: false });
    };

    openorderinnewtab = (e) => {
        const Audit = AuditTrailValidation(
            "IDS_MDL_ORDERS",
            "IDS_SCN_SHEETORDERS",
            "IDS_TSK_OPENNEWTAB"
        );

        if (Audit) {
            const passObjDet = {
                objmanualaudit: Manualauditobject("openintab", "Sheet Orders"),
                objsilentaudit: Silentauditobject("openintab", "Sheet Orders",
                    this.props.t("Orders.Sheetorders.IDS_AUDIT_PROCESSSHEETVIEW", {
                        batchid: this.props.dataItem.batchid,
                        screen: orderType(this.state.filetype),
                        Processed: "Opened in New Tab",
                        user: sessionStorage.Username,
                    })
                )
            };
            $("#newTabAudit1").modal("show");

            this.setState({
                audit: true,
                AuditUrl: this.ELNurl + "/AuditTrail/AuditConfigurationrecord",
                AuditObject: passObjDet,
                AuditPassfunction: () => {
                    this.openNewTab();
                },
                AuditFailfunction: () => {
                    console.log("Audit failed.");
                }
            });
        } else {

            let passObjDet = {
                objsilentaudit: Silentauditobject("openintab", "Sheet Orders",
                    this.props.t("Orders.Sheetorders.IDS_AUDIT_PROCESSSHEETVIEW", {
                        batchid: this.props.dataItem.batchid,
                        screen: orderType(this.state.filetype),
                        Processed: "Opened in New Tab",
                        user: sessionStorage.Username,
                    })
                )
            };
            Servicecalls(
                this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
                passObjDet,
                (res) => { },
                (res) => { }
            );

            this.openNewTab();
        }
    }

    render() {
        const { controlRights } = this.state;
        return (
            <td onMouseLeave={this.handleMouseOut} className={`k-grid-content-sticky sheetorder k-command-cell pl-0 stickyaction`}>
                {this.props.dataItem[this.props.keyfield] !== undefined ?
                    (<div className="actionsBtn flex-centered padd-actionsBtn pr-3" >

                        <div className="processOrderBtn no-margin-process rejectColm">
                            <CustomButtonCell
                                {...this.props}
                                keyfield={this.props.keyfield}
                                onclick={this.props.onorderopen}
                                screen={"Sheet"}
                            />
                        </div>

                        {(this.props.dataItem.order.ordercancell === undefined || this.props.dataItem.order.ordercancell === 0) && Number(this.props.dataItem.filecode) !== -1 ?
                            <div className="group-hover-icon">
                                <button className="" style={{ backgroundColor: "transparent", color: "#1970eb", border: "0" }} onClick={(event) => this.setClickPopover(event, this.props.dataItem.order.batchid)}><i className="fa fa-ellipsis-v"></i></button>
                                {this.state?.eventKey === this.props.dataItem.order.batchid && Number(this.props.dataItem.filecode) !== -1 &&
                                    <div className="list-view-btn-group" style={{ "left": this.state.popOverLeft, "top": this.state.popOverTop }}>
                                        <React.Fragment>
                                            {controlRights?.clone &&

                                                <button id="cancel_order" title={"Dublicate Order"} className="grid-icons" onClick={(event) => this.props.onordercommonaction(this.props.dataItem, "duplicate")}>
                                                    <i className="fas fa-clone" aria-hidden="true" title="Clone"></i>
                                                </button>
                                            }


                                            {controlRights.copy &&
                                                // <CopyToClipboard text={this.state.value}>
                                                <button
                                                    title="copy link"
                                                    className="grid-icons"
                                                    onClick={() => {
                                                        const valueToCopy = this.state.value;
                                                        if (navigator.clipboard && navigator.clipboard.writeText) {
                                                            navigator.clipboard.writeText(valueToCopy).then(() => {
                                                                console.log("Copied to clipboard!");
                                                            }).catch((err) => {
                                                                console.error("Failed to copy:", err);
                                                            });
                                                        } else {
                                                            const textarea = document.createElement("textarea");
                                                            textarea.value = valueToCopy;
                                                            document.body.appendChild(textarea);
                                                            textarea.select();
                                                            try {
                                                                document.execCommand("copy");
                                                                console.log("Copied using fallback!");
                                                            } catch (err) {
                                                                console.error("Fallback copy failed:", err);
                                                            }
                                                            document.body.removeChild(textarea);
                                                        }
                                                        this.onbuttonclick.bind(this);
                                                    }}
                                                >
                                                    {/* <i className="fas fa-copy"></i> */}
                                                    <svg style={{ width: "17px" }} fill="none" viewBox="0 0 16 16" role="presentation" className="_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31 _1bsbpxbi _4t3ipxbi"><path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"></path></svg>
                                                </button>
                                                // </CopyToClipboard>
                                            }

                                            {controlRights.share && (this.props.dataItem.sharetome === undefined || this.props.dataItem.sharetome === null) &&
                                                <Shareorder
                                                    keyfield={this.props.dataItem[this.props.keyfield]}
                                                    isshared={false}
                                                    props={this.props}
                                                    passbackorder={this.props.passbackorder}
                                                />
                                            }
                                            {this.props.dataItem.order !== undefined && this.props.dataItem.order.sharebyme !== undefined &&
                                                this.props.dataItem.order.sharebyme !== null && this.props.dataItem.order.sharebyme.length > 0 &&
                                                (<button title={"Unshare"} className="btn grid-icons" onClick={event => this.onUnShareClick(event, this.props.dataItem.order)}>
                                                    <span className="fa-stack fa-sm fa-stack-size">
                                                        <i className="fa fa-share-alt fa-stack-1x"></i>
                                                        <i className="fa fa-ban  fa-stack-2x"></i>
                                                    </span>
                                                </button>)}
                                            {Number(this.props.dataItem.filecode) !== -1 &&
                                                <Customordercells
                                                    // {...props}
                                                    keyfield={this.props.keyfield}
                                                    props={this.props}
                                                />
                                            }
                                            <button
                                                type="button"
                                                className="grid-icons"
                                                title="Open in New Tab"
                                                onClick={this.openorderinnewtab.bind(this)}
                                            >
                                                <i className="fa fa-external-link-alt"></i>
                                            </button>

                                            {controlRights.cancel && this.props.dataItem.order.canuserprocess ?
                                                <React.Fragment>

                                                    <button title={isMultitenant === 2 ? "Cancel Task" : "Cancel Order"} className="grid-icons new-close" onClick={event => this.onordercommonaction(event, this.props.dataItem)}>
                                                        {/* <svg fill="#0e5bca" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z" /></svg> */}
                                                        <i className="fa fa-times mr-1" aria-hidden="true"></i>
                                                    </button>
                                                </React.Fragment> : false
                                            }

                                            {this.props.dataItem?.order?.isclone !== true && ((this.props.dataItem?.order?.repeat === false) ? false : (this.props.dataItem?.order?.repeat && this.props.dataItem?.order?.sharetome === undefined) || (this.props.dataItem?.order?.sharetome !== undefined && this.props.dataItem?.order?.repeat && this.props.dataItem?.order?.sharetome?.some((items) => items.sharerights === 1))) ?
                                                <React.Fragment>

                                                    <button title="Stop auto" className="grid-icons stop" onClick={(event) => this.stopautoregister(event, this.props.dataItem)}
                                                    >
                                                        <i className="synccancel" aria-hidden="true"></i>
                                                    </button>
                                                </React.Fragment> : false
                                            }
                                        </React.Fragment>
                                    </div>
                                }
                            </div>
                            : Number(this.props.dataItem.filecode) !== -1 &&
                            <Customordercells
                                // {...props}
                                keyfield={this.props.keyfield}
                                props={this.props}
                            />

                        }
                        {this.state.audit &&
                            <Suspense fallback={<div></div>}>
                                <Audit
                                    AuditId="newTabAudit1"
                                    AuditUrl={this.state.AuditUrl}
                                    AuditObject={this.state.AuditObject}
                                    AuditPassfunction={this.state.AuditPassfunction}
                                    AuditFailfunction={this.state.AuditFailfunction}
                                    AuditCancelfunction={this.Auditcancel}
                                    Auditfilefunction={this.state.Auditfilefunction}
                                    alert={this.props.alert}
                                />
                            </Suspense>
                        }
                    </div>)
                    : this.props.dataItem !== undefined && this.props.dataItem.file !== undefined &&
                    <div className="actionsBtn 11 align-items-center ">
                        <Downloadfile file={this.props.dataItem.file}
                            url={this.props.filedownloadurl} />

                        <Deletefile
                            file={this.props.dataItem.file}
                            ondeletefile={this.props.ondeletefile} />

                        <Viewfile
                            file={this.props.dataItem.file}
                            url={this.props.filedownloadurl} screen={this.props.screen} />

                        {(this.props.dataItem?.file?.filename?.endsWith(".docx") || this.props.dataItem?.file?.filename?.endsWith(".xlsx")) &&
                            <EditFile
                                file={this.props.dataItem.file}
                                url={this.props.filedownloadurl} screen={this.props.screen} />
                        }

                    </div>
                }
            </td>
        );
    }
}
PendingViewCell.contextType = MyGlobalContext;
export default withAlert()(withTranslation(PendingViewCell));